exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".full-width {\n  width: 100% !important; }\n\n.basic-info {\n  display: -ms-flexbox;\n  display: flex;\n  gap: 25px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/colaboradores/new-colaborador-dialog/new-colaborador-dialog.component.scss
// module id = ../../../../../src/app/components/colaboradores/new-colaborador-dialog/new-colaborador-dialog.component.scss
// module chunks = 0